import React, { Component } from 'react';
import './Wishlist.css';
import axios from 'axios';
import Title from '../Layout/Title';

export default class Wishlist extends Component {
    state = {
        title: 'Lista de Deseos 🎁',
        wishes: [],
        loading: true,
        error: null,
    };

    componentDidMount() {
        const obtenerData = async () => {
            const url = 'https://api.kope.cl/wishlist/list';
            await axios.get(url)
                .then((response) => {
                    const wishes = response.data.data.wishes.map((w) => ({
                        id: w.id,
                        name: w.name,
                        link: w.url,
                        fulfilled: w.resolved === '1' || w.resolved === 1,
                        giftedBy: w.thanks_to || '',
                    }));
                    this.setState({ wishes, loading: false });
                })
                .catch((error) => {
                    console.log("=( NO conecta con API wishlist");
                    console.log(error);
                    this.setState({ loading: false, error: "No se pudo cargar la lista de deseos." });
                });
        };
        obtenerData();
    }

    render() {
        const { title, wishes, loading, error } = this.state;

        return (
        <div>
            <Title dataFromParent={title} />
            <div className="min-h-screen bg-black text-sky-500 flex flex-col items-center p-6 bg-opacity-90 border-gray-700 border">
                <h1 className="text-3xl font-bold mb-6"></h1>

                {loading && (
                    <p className="text-gray-400 text-lg">Cargando lista de deseos...</p>
                )}

                {error && (
                    <p className="text-red-400 text-lg">{error}</p>
                )}

                {!loading && !error && (
                <ul className="w-full max-w-2xl space-y-4">
                    {wishes.map((wish) => (
                        <li
                            key={wish.id}
                            className={`p-4 border rounded-md`}
                        >
                            <div>
                                <h2 className={`txt-lg font-semibold ${
                                        wish.fulfilled
                                            ? "border-sky-700 line-through"
                                            : "border-gray-700"
                                    }`}>{wish.name}</h2>
                                {wish.link && (
                                <a
                                    href={wish.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`text-sky-400 hover:underline ${
                                        wish.fulfilled
                                            ? "border-sky-700 line-through"
                                            : "border-gray-700"
                                    }  `}
                                >
                                    Ver enlace
                                </a>
                                )}
                                {wish.giftedBy && (
                                    <p className="text-sm text-gray-400">
                                        ¡ Gracias {" "}
                                        <span className="text-gray-100">{wish.giftedBy} !</span>
                                    </p>
                                )}
                            </div>
                        </li>
                    ))}
                </ul>
                )}
            </div>
            <div className="h-6"></div>
        </div>
        );
    }
}
